import React, { useEffect, useState } from 'react'
import { Collapse, Paper } from '@material-ui/core'
import useCurrentUserEntities from 'hooks/useCurrentUserEntities'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import AlertWrapper from 'components/AlertWrapper'
import { useHistory } from 'react-router'

export default function BannerLoader() {
  const { push: redirect } = useHistory()
  const [alertToDisplay, setAlertToDisplay] = useState(null)
  function useMissingActiveTrackedAccounts() {
    const hasNoActiveAccounts = useCurrentUserEntities('trackedAccounts').every(a => a.paused)
    const isRoundingUp = useCurrentUserProp('roundedUpJars').length > 0
    const isTithing = useCurrentUserProp('tithedJars').length > 0

    return hasNoActiveAccounts && (isRoundingUp || isTithing)
  }
  const isMissingActiveTrackedAccounts = useMissingActiveTrackedAccounts()
  const hasPendingTithes = useCurrentUserProp('unprocessedTithes').length > 0
  const deprecatedProvider = useCurrentUserEntities('trackedAccountProviders').find(e => e.deprecatedPlaidCredentials)

  // NOTE: order is important as only the first banner listed that isOn will be diplayed
  useEffect(() => {
    const alerts = [
      {
       isOn: hasPendingTithes,
       message: 'You have a transaction awaiting confirmation for a tithe contribution',
       severity: 'warning',
       actionText: 'go to my giving',
       actionHandler: () => { redirect('/home/my-giving') }
      },
      {
       isOn: !!deprecatedProvider,
       message: `${deprecatedProvider?.institutionName} requires login to reconnect account(s)`,
       severity: 'error',
       actionHandler: () => { redirect('/settings/financial') },
       actionText: 'go to settings'
      },
      {
        isOn: isMissingActiveTrackedAccounts,
        message: 'You are supporting cause(s) but have not enabled any tracked cards',
        severity: 'warning',
        actionHandler: () => { redirect('/settings/financial') },
        actionText: 'go to settings'
      }
    ]

    const alert = alerts.find(alert => alert.isOn)
    if(alert) {
      setAlertToDisplay(alert)
    } else {
      setAlertToDisplay(null)
    }
  }, [isMissingActiveTrackedAccounts, hasPendingTithes, deprecatedProvider, redirect])

  return (
    <Collapse in={!!alertToDisplay} unmountOnExit>
      <Paper elevation={0} variant='outlined' square>
        <AlertWrapper { ...alertToDisplay } />
      </Paper>
    </Collapse>
  )
}
